<template>
  <section class="questions-hub">
    <h2 v-if="!hideTitle" class="body-title">{{ t('question_hub') }}</h2>

    <UiCollapse v-for="q in items" :key="q.name" buttonReversed class="mb8">
      <template #label>{{ q.name }}</template>
      <template #items>
        <p class="pl32" v-html="q.value">
        </p>
      </template>
    </UiCollapse>
  </section>
</template>

<script lang="ts" setup>
import type {MarketFullInfoQa} from "~/graphql/generated/schema-types";

const props = defineProps<{
  items: MarketFullInfoQa[],
  hideTitle?: boolean
}>()

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.questions-hub {
  &:deep(.collapse) {
    border-radius: 8px;

    &:not(.hide) {
      background: transparent;
    }

    .collapse_header {
      &__btn.btn {
        gap: 20px;
        padding: 1.6rem 20px !important;

        &:hover {
          opacity: 0.8;
        }

        .f16 {
          font-size: 18px;
          color: var(--surfaces-on-surface);
          font-style: normal;
          font-weight: 800;
          line-height: normal;
        }
      }
    }
  }

  .pl32 {
    padding-left: 32px;
    color: var(--surfaces-on-surface-variable);
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px; /* 200% */
  }

  .body-title {
    margin-bottom: 32px;
  }
}
</style>
